import React, { useState, useEffect } from "react";
import { FiAlertTriangle, FiActivity, FiSlash, FiTarget, FiRefreshCw } from "react-icons/fi";
import "../assets/css/Dashboard.css"
export default function QuickAnalysis({ alertView, handleAlertChange, selectedAlert, clearAlert, endemicityCounts, sortedDiseaseHotspots }) {
  const [loading, setLoading] = useState(true);
  const [highCount, setHighCount] = useState(0);
  const [mediumCount, setMediumCount] = useState(0);
  const [lowCount, setLowCount] = useState(0);
  const [noDataCount, setNoDataCount] = useState(0);
  const renderEndemicity = () => {
    try {
      if (endemicityCounts.High != null || endemicityCounts.Medium != null || endemicityCounts.Low != null || endemicityCounts["No Data"] != null) {
        setHighCount(endemicityCounts.High ?? 0);
        setMediumCount(endemicityCounts.Medium ?? 0);
        setLowCount(endemicityCounts.Low ?? 0);
        setNoDataCount(endemicityCounts["No Data"] ?? 0);
        setLoading(false)
      }
    }
    catch (error) {
      console.error("Error rendering endemicity:", error);
    }
  };
  useEffect(() => {
  if (sortedDiseaseHotspots.length === 0) {
    setHighCount(endemicityCounts.High ?? 0);
    setMediumCount(endemicityCounts.Medium ?? 0);
    setLowCount(endemicityCounts.Low ?? 0);
    setNoDataCount(endemicityCounts["No Data"] ?? 0);
  } else {
    renderEndemicity();
  }
}, [sortedDiseaseHotspots]);

  const stats = [
    {
      title: "High",
      count: highCount,
      icon: FiAlertTriangle,
      color: "bg-red-100 text-red-700",
    },
    {
      title: "Medium",
      count: mediumCount,
      icon: FiActivity,
      color: "bg-orange-100 text-orange-700",
    },
    {
      title: "Low",
      count: lowCount,
      icon: FiTarget,
      color: "bg-green-100 text-green-700",
    },

    {
      title: "No Data",
      count: noDataCount,
      icon: FiSlash,
      color: "bg-blue-100 text-blue-700",
    },
  ];

  const loader = [
    {
      id: 1,
      title: "",
      count: ""
    },
    {
      id: 2,
      title: "",
      count: ""
    },
    {
      id: 3,
      title: "",
      count: ""
    },
    {
      id: 4,
      title: "",
      count: ""
    }
  ]

  const colorMap = {
    "bg-red-100": "bgRed100",
    "text-red-700": "textRed700",
    "bg-orange-100": "bgOrange100",
    "text-orange-700": "textOrange700",
    "bg-green-100": "bgGreen100",
    "text-green-700": "textGreen700",
    "bg-blue-100": "bg-blue-100",
    "text-blue-700": "text-blue-700"
  };

  return (
    <div className="quickAnalysisContainer">
      <div className="quickAnalysisContent">
        <div className="quickAnalysisHeaderCustom">
          <h2 className="quickAnalysisTitle">Alert Status</h2>
          <div className="filterDropdown">
            {selectedAlert && (
              <button
                className="clear-filter-dashboard" style={{ padding: "6px 16px", marginLeft: "10px" }}
                onClick={clearAlert}
              >
                Clear
              </button>
            )}
          </div>
        </div>
        {loading && (
          <div className="statsGrid-skeleton">
            {loader.map((item) => {
              return (
                <div
                  key={item.id}
                  className="statCard"
                >
                  <div className="statHeader">
                    <div className="iconContainer">
                    </div>
                    <span className="countBadge-skeleton">
                      {item.count}
                    </span>
                  </div>
                  <div className="statTitle-skeleton">
                    {item.title}
                  </div>
                </div>
              );
            })}
          </div>
        )}
        {!loading && (
          <div className="statsGrid">
            {stats.map((item) => {
              const IconComponent = item.icon;
              const [bgClass, textClass] = item.color.split(" ");
              const iconBgClass = colorMap[bgClass] || "";
              const iconTextClass = colorMap[textClass] || "";

              return (
                <div
                  key={item.title}
                  onClick={() => handleAlertChange(item.title)}
                  className={`statCard ${selectedAlert === item.title ? "activeCard" : ""}`}
                >
                  <div className="statHeader">
                    <div className={`iconContainer ${iconBgClass}`}>
                      <IconComponent className={`w-5 h-5 ${iconTextClass}`} />
                    </div>
                    <div className="countBadge">
                      {item.count && (
                        <span >{item.count}</span>
                      )}
                    </div>
                  </div>
                  <div className="statTitle">{item.title}</div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}

